const normalizeYesNoValue = (value) => {
	if (value === 1 || value === "1" || value === true) {
		return "yes";
	}
	if (value === 0 || value === "0" || value === false) {
		return "no";
	}
	if (typeof value === "string") {
		const trimmedValue = value.trim().toLowerCase();
		if (trimmedValue === "yes" || trimmedValue === "true") {
			return "yes";
		}
		if (trimmedValue === "no" || trimmedValue === "false") {
			return "no";
		}
	}
	return "";
};

const lookupField = (fieldsById, fieldId) => {
	if (!fieldsById || fieldId === undefined || fieldId === null || fieldId === "") {
		return null;
	}
	return fieldsById[fieldId] || fieldsById[String(fieldId)] || fieldsById[Number(fieldId)] || null;
};

const controllingValueMatches = (controllingField, expectedValue) => {
	const actualValue = controllingField?.value;
	if (controllingField?.field_type === "yes/no") {
		const normalizedActualValue = normalizeYesNoValue(actualValue);
		const normalizedExpectedValue = normalizeYesNoValue(expectedValue);
		return normalizedActualValue !== "" && normalizedActualValue === normalizedExpectedValue;
	}
	return String(actualValue ?? "") === String(expectedValue ?? "");
};

export const isFieldShowConditionMet = (field, fieldsById, visitingFieldIds = new Set()) => {
	if (!field) {
		return false;
	}
	const conditionalList = field.conditional_list;
	if (conditionalList === undefined || conditionalList === null || conditionalList === "") {
		return true;
	}

	const fieldIdKey = String(field.id);
	if (visitingFieldIds.has(fieldIdKey)) {
		return false;
	}
	visitingFieldIds.add(fieldIdKey);

	const conditionalParts = String(conditionalList).split(",");
	for (let pairIndex = 0; pairIndex + 1 < conditionalParts.length; pairIndex += 2) {
		const controllingField = lookupField(fieldsById, conditionalParts[pairIndex]);
		if (!controllingField) {
			continue;
		}
		const expectedValue = conditionalParts[pairIndex + 1].replaceAll("[comma1]", ",");
		if (
			controllingValueMatches(controllingField, expectedValue) &&
			isFieldShowConditionMet(controllingField, fieldsById, visitingFieldIds)
		) {
			visitingFieldIds.delete(fieldIdKey);
			return true;
		}
	}

	visitingFieldIds.delete(fieldIdKey);
	return false;
};

const sectionHasShowCondition = (section) => {
	const sectionConditionId = section?.section_condition_id;
	if (sectionConditionId === undefined || sectionConditionId === null || sectionConditionId === "") {
		return false;
	}
	return Number(sectionConditionId) !== 0;
};

const sectionConditionMatches = (conditionType, currentValue, conditionValue, fieldType) => {
	if (fieldType === "yes/no" && conditionType === "=") {
		const normalizedCurrentValue = normalizeYesNoValue(currentValue);
		const normalizedConditionValue = normalizeYesNoValue(conditionValue);
		return normalizedCurrentValue !== "" && normalizedCurrentValue === normalizedConditionValue;
	}
	if (conditionType === ">=") {
		return parseInt(currentValue, 10) >= parseInt(conditionValue, 10);
	}
	if (conditionType === ">") {
		return parseInt(currentValue, 10) > parseInt(conditionValue, 10);
	}
	if (conditionType === "=") {
		return String(currentValue ?? "") === String(conditionValue ?? "");
	}
	if (conditionType === "<") {
		return parseInt(currentValue, 10) < parseInt(conditionValue, 10);
	}
	if (conditionType === "<=") {
		return parseInt(currentValue, 10) <= parseInt(conditionValue, 10);
	}
	return false;
};

export const isSectionShowConditionMet = (section, fieldsById) => {
	if (!sectionHasShowCondition(section)) {
		return true;
	}
	const controllingField = lookupField(fieldsById, section.field_condition_id);
	if (!controllingField || controllingField.value === undefined || controllingField.value === null || controllingField.value === "") {
		return false;
	}
	return sectionConditionMatches(section.condition_type, controllingField.value, section.condition_value, controllingField.field_type);
};

const buildFieldsById = (sections) => {
	const fieldsById = {};
	for (const section of sections || []) {
		for (const field of section.fields || []) {
			fieldsById[field.id] = field;
			fieldsById[String(field.id)] = field;
		}
	}
	return fieldsById;
};

export const mergeAerialSectionsWithProjectConditions = (aerialSections, projectSections) => {
	console.log("aerialSections", aerialSections);
	console.log("projectSections", projectSections);
	const projectSectionsById = {};
	for (const projectSection of projectSections || []) {
		projectSectionsById[projectSection.id] = projectSection;
		projectSectionsById[String(projectSection.id)] = projectSection;
	}

	return (aerialSections || []).map((aerialSection) => {
		const projectSection = projectSectionsById[aerialSection.id] || projectSectionsById[String(aerialSection.id)];
		if (!projectSection) {
			return aerialSection;
		}
		return {
			...aerialSection,
			section_condition_id: projectSection.section_condition_id,
			field_condition_id: projectSection.field_condition_id,
			condition_type: projectSection.condition_type,
			condition_value: projectSection.condition_value,
		};
	});
};

export const getVisibleAerialSections = (sections) => {
	const fieldsById = buildFieldsById(sections);
	return (sections || [])
		.filter((section) => isSectionShowConditionMet(section, fieldsById))
		.map((section) => ({
			...section,
			fields: (section.fields || []).filter((field) => isFieldShowConditionMet(field, fieldsById)),
		}))
		.filter((section) => section.fields.length > 0);
};

export const getVisibleAerialFieldIds = (sections) => {
	const visibleFieldIds = new Set();
	for (const section of getVisibleAerialSections(sections)) {
		for (const field of section.fields || []) {
			visibleFieldIds.add(field.id);
		}
	}
	return visibleFieldIds;
};
